import Vue from 'vue'
import Vuex from 'vuex'
import { requestToken, save, remove } from '@/util/token'
import accountService from '@/services/account.service'
import dialog from '@/services/dialog.service'
import ErrorDialog from '@/components/dialogs/ErrorDialog'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentPage: {
      title: '',
    },
    user: {
      userId: undefined,
      companyCode: undefined,
      loginId: undefined,
      isAdmin: undefined,
      requiresPasswordChange: true,
    },
    service: {
      available: false,
      message: undefined,
      timeOpen: undefined,
      timeClose: undefined,
    },
    // Envから企業一覧を取得する処理は廃止します。
    // TODO 使用箇所を精査し、最終的にはこのstateは削除します。
    companies: [],
  },
  mutations: {
    setUser(state, user) {
      state.user.userId = user.userId
      state.user.companyCode = user.companyCode
      state.user.loginId = user.loginId
      state.user.isAdmin = user.isAdmin
      state.user.requiresPasswordChange = user.requiresPasswordChange
    },
    setCurrentPage(state, data) {
      state.currentPage = data
    },
    setServiceStatus(state, { available, message, timeOpen, timeClose }) {
      state.service.available = available
      state.service.message = message
      state.service.timeOpen = timeOpen
      state.service.timeClose = timeClose
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const loginId = credentials.loginId
      let isAdmin = false
      let requiresPasswordChange = true

      const authResponse = await requestToken(credentials)
      const userId = authResponse.userId
      const companyCode = credentials.companyCode

      save(
        userId,
        companyCode,
        loginId,
        authResponse.accessToken,
        authResponse.refreshToken,
        authResponse.refreshUrl,
        authResponse.expiresAt,
      )

      if (authResponse.refreshToken) {
        // リフレッシュトークンがもらえるということはパスワード変更（初期パスワードを
        // ユーザー自身が変更するやつ）が済んでいる。
        requiresPasswordChange = false
      }

      // ユーザーの権限情報などは一度サーバーに問い合わせないと分からないので、
      // 認証がOKだったら改めてリクエストする
      // TODO パスワード変更が必要な場合はそもそもここまで来てはいけない気がする。
      try {
        const account = await accountService.getAccount(companyCode, loginId)
        isAdmin = account.roles.includes('admin')
      } catch (e) {
        throw e
      }

      commit('setUser', {
        userId,
        companyCode,
        loginId,
        isAdmin,
        requiresPasswordChange,
      })
    },
    logout({ state }) {
      state.user.userId = undefined
      state.user.loginId = undefined
      state.user.companyCode = undefined
      state.user.isAdmin = false
      remove()
    },
    serverError(store, error) {
      console.error(error)
      dialog.open(ErrorDialog, {
        message: 'サーバーエラーが発生しました :_(',
        subMessage: `管理者にお問い合わせください。`,
      })
    },
  },
})
